import React, { Fragment, useState, useEffect } from 'react';
import MapStyleConfigRow from '../components/MapStyleConfigRow';
import MapFitBoundsRow from '../components/MapFitBoundsRow';
import MapFitBoundsControl from '../components/MapFitBoundsControl';
import { connect } from 'react-redux';

export default function MapConfigContainer(props) {
  // sidlo-turistautak-osm-20210915
  if (props.map) {
    //console.log(props.map.getLayer('sidlo-turistautak-osm-20210915'))
    //const visibility = props.map.getLayoutProperty(
    //  'sidlo-turistautak-osm-20210915',
    //  'visibility'
    //  );
    //console.log('sidlo-turistautak-osm-20210915: ', visibility) // 'visibility'  

    // map.setLayoutProperty(clickedLayer, 'visibility', 'none');
  }

  return (
    <div>
       {/*<MapFitBoundsControl
        getMap={this.props.getMap}
        itemMoLastStates={this.props.itemMoLastStates}
        itemLastStateVisible={this.props.itemLastStateVisible}
      />
      <div>
        <MapFitBoundsRow
          name={'zoom'}
          map={this.props.map}
          itemMoLastStates={this.props.itemMoLastStates}
          itemLastStateVisible={this.props.itemLastStateVisible}
        />
      </div>
      */}
      <div> 

      </div>
      <div>
        <MapStyleConfigRow
          map={props.map}
        />
        </div>
    </div>
    ) ;

}
